angular.module('unica_invitation_group.invitation_group_controllers')

.controller('InvitationGroupCreateController', function(
	$rootScope, $scope, $state, $stateParams,
	InvitationGroupCreateService
) {
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.resetInvitationGroupData();

	$scope.saveInvitationGroup = function()
	{
		$scope.showLoader();

		InvitationGroupCreateService
			.create( $scope.event_id, $scope.invitationGroupData )
			.then(function(data) {
				$scope.hideLoader();

				console.log(data);
				if ( data ) {
					$scope.showSuccessMsg('Gruppo creato con successo!', '');

					$state.go('app.invitation_group.list', { event_id: $stateParams.event_id });
					// $state.go('app.invitation_group.assign', { event_id: $stateParams.event_id, id: data.id });
				}
			});
	};

});


